import { render, staticRenderFns } from "./GvsCriteriaCard.vue?vue&type=template&id=69689520&scoped=true&"
import script from "./GvsCriteriaCard.vue?vue&type=script&lang=js&"
export * from "./GvsCriteriaCard.vue?vue&type=script&lang=js&"
import style0 from "./GvsCriteriaCard.vue?vue&type=style&index=0&id=69689520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69689520",
  null
  
)

export default component.exports